import { Calendar } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function SchedulesPage() {
  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">Schedules</h1>
        <p className="text-sm text-muted-foreground">
          We're in the testing phase — every run is manual. Schedules show up here when we move
          to automated cadence.
        </p>
      </header>

      <Card>
        <CardHeader className="flex flex-row items-center gap-3 space-y-0">
          <Calendar className="h-5 w-5 text-muted-foreground" />
          <CardTitle>Future home: Temporal Schedules</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-muted-foreground">
          <p>
            Once we ratify cadence (e.g. <code>3× content / day / persona</code>), this page will
            list active schedules — type, cron, last fired, next fire, paused state — and let you
            create / pause / delete them. Backend primitive is Temporal's Schedule API.
          </p>
          <ul className="list-inside list-disc space-y-1">
            <li>Create persona-gen on cron (weekly seed run).</li>
            <li>Create content-gen with persona/provider matrix on cron.</li>
            <li>Pause without losing schedule history.</li>
            <li>One-shot "run now" to test a schedule definition.</li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
